var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('TextEditor',{attrs:{"editable":_vm.editable},model:{value:(_vm.block.data.text),callback:function ($$v) {_vm.$set(_vm.block.data, "text", $$v)},expression:"block.data.text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }